<div>
    <mat-expansion-panel
            class="light-flex-card tv-mat-expansion-indicator-light-bg"
            #panel
            (opened)="onPanelOpened()"
            (closed)="onPanelClosed()"
    >
        <mat-expansion-panel-header>
            <mat-panel-title class="sub-title">
                CGRP Off
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div>
          Ecran(s) inlu(s) dans CGRP Off
        </div>
        <div class="cgrp_off_options">
          <mat-checkbox class="tv-ns-blue-checkbox horizontal-checkbox option-checkbox" *ngFor="let option of cgrpOffOptions" [formControl]="option.control">
            {{ option.label }}
          </mat-checkbox>
        </div>

        <div class="header-item-filters">
            <button
                    (click)="editCGRPOffModal()"
                    [ngClass]="{'fade-in-right': panelOpened, 'fade-out-left': !panelOpened}"
                    class="tv-round-icon-button-icon-small-light-blue"
            >
                <mat-icon>add</mat-icon>
            </button>

            <span *ngIf="isContractOffLoading">
              <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
            </span>
        </div>

        <div class="container" *ngIf="!isContractOffLoading">
            <div class="item" *ngFor="let line of contractOffList">
                <div class="item-content">
                    <div class="item-header">
                        <span class="title">{{ line.target ? line.target.name : '' }}</span>
                        <span class="date-range">{{ line.startDate }} - {{ line.endDate }}</span>
                        <span class="ca">{{ line.value }} €</span>
                    </div>

                    <div class="item-options">
                      <ng-container *ngIf="line.conditions.length > 0">
                        <mat-icon *ngIf="line.conditions[0].isInclude" class="option-type-icon"
                                      svgIcon="add-circle-fill"></mat-icon>
                            <mat-icon *ngIf="!line.conditions[0].isInclude" class="option-type-icon"
                                      svgIcon="delete-circle-fill"></mat-icon>
                        <ng-container *ngFor="let condition of line.conditions">
                            <div class="option-products">
                                <span>{{condition?.category.name}}</span>
                            </div>
                        </ng-container>
                      </ng-container>
                    </div>
                    <div class="item-actions">
                        <mat-icon svgIcon="edit" (click)="editCGRPOffModal(line, 'edit')"></mat-icon>
                        <mat-icon svgIcon="content-copy" (click)="dupCGRPOff(line)"></mat-icon>
                        <mat-icon svgIcon="delete-bin" (click)="confirmDelete(line)"></mat-icon>
                    </div>
                </div>
            </div>
        </div>

    </mat-expansion-panel>
</div>
